module.exports = __webpack_public_path__ + "img/ico_add.78d8813f.svg";